import { AppShell } from "../components/AppShell";
import { MissionGraphFlow } from "../components/MissionGraphFlow";
import { OverviewTopbar, ProjectsRow } from "../components/OverviewTopbar";
import { ScanStrip } from "../components/ScanStrip";
import { isProjectVerified } from "../api";
import { useAppState } from "../AppStateContext";
import { useI18n } from "../i18n";
import "./overview.css";

export default function GraphPage() {
  const { projects, activeProject, setActiveProjectId, activeScan, viewedScan } = useAppState();
  const { t } = useI18n();
  const displayScan = viewedScan ?? activeScan;
  const activeScanId = displayScan?.scan_id ?? null;

  return (
    <AppShell>
      <div className="overview overview--graph anim-page">
        <OverviewTopbar />
        <ProjectsRow
          searches={projects.map((p) => ({
            id: p.project_id,
            label: p.name,
            verified: isProjectVerified(p),
          }))}
          activeId={activeProject?.project_id}
          onSelect={setActiveProjectId}
        />
        <ScanStrip />

        <p className="overview__section-label" style={{ margin: "12px 0 8px" }}>
          {t("graph.sectionLabel")}
        </p>
        <MissionGraphFlow scanId={activeScanId} fill />
      </div>
    </AppShell>
  );
}
